import { useAppStore } from '@/modules/apps/store';
import { RouteLocationRaw, useRouter } from 'vue-router';

export function useAppRouter() {
    const router = useRouter();
    const appStore = useAppStore();

    const withAppId = (routeLocation: RouteLocationRaw): RouteLocationRaw => {
        if (typeof routeLocation === 'object' && routeLocation !== null && 'name' in routeLocation) {
            routeLocation = {
                ...routeLocation,
                params: {
                    ...(routeLocation as any).params,
                    appId: appStore.appId
                }
            };
        }

        return routeLocation;
    };

    const push = (routeLocation: RouteLocationRaw) => router.push(withAppId(routeLocation));
    const resolve = (routeLocation: RouteLocationRaw) => router.resolve(withAppId(routeLocation));

    return { ...router, push, resolve, withAppId };
}
